@if (institutionId > 0) {
  <div id="submodule-documents" class="cw-module-card">
    <phscw-documents
      backendController="Documents"
      type="institutions"
      [displayGridId]="displayGridId"
      [entityId]="institutionId"
      [allowFileUpload]="allowFileUpload"
      [ignoreFilter]="ignoreFilter"
      [gridDisplayedColumns]="displayedColumns">
      <!-- Header -->
      <div class="cw-flex-row">
        <!-- Modul-Titel -->
        <h2>{{ 'GENERAL.DOCUMENTS' | translate }}</h2>
      </div>
    </phscw-documents>
  </div>
}
